import { message } from 'antd';

type VariantType = 'default' | 'success' | 'error' | 'info' | 'warning';

// Configuration globale pour Ant Design message
message.config({
  top: 70,
  duration: 3,
  maxCount: 3,
});

// Create a simpler utility object for global usage using Ant Design message
export const snackActions = {
  success: (msg: string) => message.success(msg),
  warning: (msg: string) => message.warning(msg),
  info: (msg: string) => message.info(msg),
  error: (msg: string) => message.error(msg),
  toast: (msg: string, type: VariantType = 'default') => {
    if (type === 'default' || type === 'info') {
      return message.info(msg);
    }
    return message[type](msg);
  },
};

// For backward compatibility
export const SnackbarUtilsConfigurator = () => null;
